var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-menu',_vm._g(_vm._b({attrs:{"role":"menu","content-class":_setup.twMerge(
      'bg-white ring-1 ring-black ring-opacity-5 rounded-md shadow-lg',
      _vm.twClass,
    )},scopedSlots:_vm._u([{key:"activator",fn:function(data){return [_vm._t("trigger",null,null,data)]}}],null,true)},'v-menu',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }